import { styled } from '@mui/material/styles';
import { Stack, Typography, IconButton, Box } from '@mui/material';
import { abyssColors } from '@/theme/colors';

export const ImgNavButton = styled(IconButton)(() => ({
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  color: abyssColors.primary[700],
  backgroundColor: abyssColors.neutral[200],
  width: '3.2rem',
  height: '3.2rem',
  zIndex: 2,
  '&:hover': {
    backgroundColor: abyssColors.neutral[300],
  },
}));

export const DialogContentStyle = {
  flex: 1,
  minHeight: 0,
  display: 'flex',
  overflowY: 'auto',
  position: 'relative',
  scrollBehavior: 'smooth',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
};

export const MainContentContainer = styled(Stack)(() => ({
  flex: 1,
  minWidth: 0,
  position: 'relative',
  padding: '2.4rem',
  overflowY: 'auto',
  scrollBehavior: 'smooth',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
}));

export const MainImageContainer = styled(Box)(() => ({
  width: '100%',
  height: '60vh',
  position: 'relative',
  overflow: 'hidden',
  background: '#000',
}));

export const MainImage = styled('img')(() => ({
  width: '100%',
  height: '100%',
  objectFit: 'contain',
  borderRadius: '2px',
}));

export const ZoomControlsContainer = styled(Box)(() => ({
  position: 'absolute',
  bottom: 16,
  right: 16,
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: 'rgba(0, 0, 0, 0.7)',
}));

export const ZoomButton = styled(IconButton)(() => ({
  color: abyssColors.neutral[50],
  borderRadius: '5px',
  '&:disabled': {
    color: abyssColors.neutral[300],
  },
}));

export const ImageNumbering = styled(Typography)(() => ({
  fontWeight: 700,
  fontSize: '1.4rem',
  color: abyssColors.primary[700],
}));

export const ThumbnailContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  overflowX: 'auto',
  height: '13.5rem',
  gap: '16px',
  flexWrap: 'nowrap',
  msOverflowStyle: 'none',
  scrollbarWidth: 'none',
  scrollBehavior: 'smooth',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
}));

export const ThumbnailItem = styled(Box)<{ isSelected: boolean }>(({ isSelected }) => ({
  width: '22rem',
  height: '100%',
  flexShrink: 0,
  border: isSelected
    ? `4px solid ${abyssColors.primary[300]}`
    : `2px solid ${abyssColors.primary[200]}`,
  borderRadius: '4px',
  overflow: 'hidden',
  cursor: 'pointer',
  position: 'relative',
  transition: 'border-color 0.2s ease',
}));

export const ThumbnailImage = styled('img')(() => ({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
}));

export const ThumbnailMenuWrapper = styled(Box)(() => ({
  position: 'absolute',
  top: '10px',
  right: '10px',
  zIndex: 2,
}));

export const ThumbnailMenuButton = styled(Box)(() => ({
  background: abyssColors.primary[50],
  border: `1px solid ${abyssColors.primary[200]}`,
  borderRadius: '50%',
  width: 25,
  height: 25,
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));
